import { message } from "antd";
import { Dispatch, SetStateAction } from "react";
import { useSelectOptions } from "../../../../hooks/search";
import { SelectOption } from "../../../../types/select";

type UseTenantsSearchOptions = {
  selectedSearchBy: string;
  setSelectedSearchBy: Dispatch<SetStateAction<string>>;
  setSearchValue: Dispatch<SetStateAction<string>>;
};

export const useTenantsSearch = (options: UseTenantsSearchOptions) => {
  const { selectedSearchBy, setSelectedSearchBy, setSearchValue } = options;

  const { selectOptions } = useSelectOptions({ selectedSearchBy });

  function handleSearch(value: string) {
    const length = value?.length ?? 0;

    if (length === 0) {
      setSearchValue("");
      return;
    }

    if (length < 2) {
      message.error("Please enter at least two characters");
      return;
    }

    setSearchValue(value);
  }

  function handleChangeSearchBy(option: SelectOption) {
    setSelectedSearchBy(String(option?.value));
    setSearchValue("");
  }

  return { selectOptions, handleSearch, handleChangeSearchBy };
};
